export class GuarantorAppModel {
    
        constructor(
          public firstname: string,
          public middlename: string,
          public lastname: string,
          public phoneNumber1: string,
          public phoneNumber2: string,
          public relationship: string,
          public relationshipDuration: string,
          public emailAddress: string,
          public address: string,
          public bvn: string,
        ) {
    
        }
    }

